import "../../sass/style.scss"

import SimpleSlider from './simple-slider';
import LightBox from "./lightbox";

function scrollTo(anchor) {
  const $target = jQuery(anchor);
  let offset = 0;
  if ($target.length) {
    offset = $target.offset().top - 123;
  }
  // Minimize Mobile nav if expanded
  jQuery('#site-navigation').removeClass('toggled').find('.menu').attr('aria-expanded', false);

  jQuery('html, body').animate({
    'scrollTop': offset
  }, 500, 'swing');
}

jQuery(document).ready(() => {
  jQuery('a[href*="#"]').click(function (e) {
    if (e.target.className.indexOf('wpml-ls-item-toggle') > -1) {
      return true;
    }
    if (typeof e.target.href !== typeof undefined) {
      if ((e.target.href.charAt(0) === '#') || ((e.target.origin + e.target.pathname) === (window.location.origin + window.location.pathname))) {
        e.preventDefault();
        scrollTo(e.target.hash);
        return false;
      }
    } else {
      return true;
    }
  });

  const $archivePosts = jQuery('.post.archived');
  $archivePosts.click(function (e) {
    e.preventDefault();
    $archivePosts.removeClass('open');
    jQuery(this).addClass('open');
    return false;
  });

  const $sliders = jQuery('.is-style-simple-slider');
  if ($sliders.length) {
    $sliders.each(function () {
      const $this = jQuery(this);
      const autoSlide = !$this.parent().hasClass('post');
      new SimpleSlider($this, autoSlide);
    })
  }

  jQuery('.popup-close').click(function () {
    jQuery('#lacopine-popup').hide();
    document.cookie = 'lcPopupClosed=1;path=/;max-age=604800';
  });

  let lb = null;
  const lbEl = jQuery('#lightbox');
  if (lbEl.length) {
    const lb = new LightBox(lbEl);

    const $offers = jQuery('.lacopine-offers-wrap');
    if ($offers.length) {
      lb.content = $offers.find('.gallery-imgs');
    }

    function onClickOffer() {
      if ($offers.length) {
        lb.activeSlide = jQuery(this).data('itemnr');
        lb.open();
      } else {
        const gallery = jQuery(this).find('.gallery-imgs');
        if (gallery.length) {
          if (lb.content === null || (gallery.data('pid') !== lb.content.data('pid'))) {
            lb.content = gallery.clone();
          }
          lb.open();
        }
      }
    }

    jQuery('article.lacopine_collection, article.lacopine-offer').on('click', onClickOffer);

    lbEl.on('images_changed', () => {
      // Refresh click-listeners
      jQuery('article.lacopine_collection, article.lacopine-offer')
        .off('click', onClickOffer)
        .on('click', onClickOffer);

    });
  }

  jQuery('.load-more').click(function (e) {
    e.preventDefault();
    const $this = jQuery(this).addClass('loading');
    const page = parseInt($this.data('page'));
    const postType = $this.data('type');

    jQuery.post(
      wpVars.ajaxurl,
      {
        action: 'load_offers',
        page,
        postType
      },
      (res) => {
        $this.removeClass('loading');
        if (res.hasOwnProperty('html') && res.html.length > 1) {
          if (postType === 'lacopine_offers') {
            jQuery('.offers-wrap-inner').append(res.html);
          } else {
            jQuery('.entries-wrap').append(res.html);
          }

          const $lightbox = jQuery('#lightbox');
          if (res.hasOwnProperty('images')) {
            $lightbox.find('.images > .gallery-imgs').append(res.images);
          }
          $lightbox.trigger('images_changed');

          if (res.hasOwnProperty('buttonData')) {
            $this.data('page', res.buttonData);
          } else {
            $this.remove();
          }

        }
      },
      'json'
    ).fail((err) => {
      $this.removeClass('loading');
      console.error(err);
    });

    return false;
  });
});